import { render, staticRenderFns } from "./addTargetPage.vue?vue&type=template&id=9ba67bd2&scoped=true&"
import script from "./addTargetPage.vue?vue&type=script&lang=js&"
export * from "./addTargetPage.vue?vue&type=script&lang=js&"
import style0 from "./addTargetPage.vue?vue&type=style&index=0&id=9ba67bd2&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ba67bd2",
  null
  
)

export default component.exports